// Guide metadata and configuration
export const GUIDE_CATEGORIES = {
  LATEX: 'LaTeX Tools',
  WORD_PROC: 'Word Processors',
  RESEARCH: 'Research Tools'
};

export const GUIDES = [
  {
    id: 'microsoft-word',
    slug: 'importing-microsoft-word',
    title: 'Importing References into Microsoft Word',
    description: 'Learn how to export your Ref-Lex references and use them in Microsoft Word documents with built-in citation tools.',
    category: GUIDE_CATEGORIES.WORD_PROC,
    icon: '📄',
    difficulty: 'Beginner',
    estimatedTime: '5 min',
    keywords: ['microsoft word', 'citations', 'word processing', 'bibliography', 'docx'],
    relatedGuides: ['overleaf', 'r-markdown']
  },
  {
    id: 'overleaf',
    slug: 'importing-overleaf',
    title: 'Using References in Overleaf',
    description: 'Step-by-step guide to exporting BibTeX from Ref-Lex and importing it into your Overleaf LaTeX projects.',
    category: GUIDE_CATEGORIES.LATEX,
    icon: '🍃',
    difficulty: 'Beginner',
    estimatedTime: '5 min',
    keywords: ['overleaf', 'latex', 'bibtex', 'online editor', 'collaboration'],
    relatedGuides: ['texstudio', 'texmaker', 'typst']
  },
  {
    id: 'quarto',
    slug: 'importing-quarto',
    title: 'Integrating with Quarto Documents',
    description: 'Use your Ref-Lex bibliography in Quarto documents for reproducible research reports and presentations.',
    category: GUIDE_CATEGORIES.RESEARCH,
    icon: '📊',
    difficulty: 'Intermediate',
    estimatedTime: '7 min',
    keywords: ['quarto', 'reproducible research', 'markdown', 'pandoc', 'bibliography'],
    relatedGuides: ['r-markdown', 'overleaf']
  },
  {
    id: 'typst',
    slug: 'importing-typst',
    title: 'Using References with Typst',
    description: 'Configure Typst to work with your Ref-Lex bibliography for modern, fast document typesetting.',
    category: GUIDE_CATEGORIES.LATEX,
    icon: '📝',
    difficulty: 'Intermediate',
    estimatedTime: '6 min',
    keywords: ['typst', 'modern typesetting', 'bibliography', 'citations'],
    relatedGuides: ['overleaf', 'quarto']
  },
  {
    id: 'texstudio',
    slug: 'importing-texstudio',
    title: 'Setting Up TeXstudio Integration',
    description: 'Configure TeXstudio to recognize and use your Ref-Lex exported BibTeX files seamlessly.',
    category: GUIDE_CATEGORIES.LATEX,
    icon: '🔧',
    difficulty: 'Beginner',
    estimatedTime: '6 min',
    keywords: ['texstudio', 'latex editor', 'bibtex', 'desktop editor', 'configuration'],
    relatedGuides: ['texmaker', 'overleaf']
  },
  {
    id: 'texmaker',
    slug: 'importing-texmaker',
    title: 'Using References with TeXmaker',
    description: 'Set up TeXmaker to work with your Ref-Lex bibliography files for LaTeX document creation.',
    category: GUIDE_CATEGORIES.LATEX,
    icon: '✏️',
    difficulty: 'Beginner',
    estimatedTime: '5 min',
    keywords: ['texmaker', 'latex editor', 'bibtex', 'desktop editor'],
    relatedGuides: ['texstudio', 'overleaf']
  },
  {
    id: 'r-markdown',
    slug: 'importing-r-markdown',
    title: 'Integrating with R Markdown',
    description: 'Use Ref-Lex references in R Markdown documents for data analysis reports with proper citations.',
    category: GUIDE_CATEGORIES.RESEARCH,
    icon: '📈',
    difficulty: 'Intermediate',
    estimatedTime: '7 min',
    keywords: ['r markdown', 'rmarkdown', 'r studio', 'data science', 'reproducible research'],
    relatedGuides: ['quarto', 'microsoft-word']
  }
];

// Helper function to get guide by slug
export const getGuideBySlug = (slug) => {
  return GUIDES.find(guide => guide.slug === slug);
};

// Helper function to get related guides
export const getRelatedGuides = (guideId) => {
  const guide = GUIDES.find(g => g.id === guideId);
  if (!guide || !guide.relatedGuides) return [];

  return guide.relatedGuides
    .map(id => GUIDES.find(g => g.id === id))
    .filter(Boolean);
};

// Helper function to filter guides by category
export const getGuidesByCategory = (category) => {
  if (!category) return GUIDES;
  return GUIDES.filter(guide => guide.category === category);
};
